<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import router from "../../router";
import moment from "moment";

import CustomerDateRangePicker from '@/components/CustomerDateRangePicker'

export default {
  name: "TimeCard",
  components: {
    Pagination,
    ErrorComponent,
    Alert,
    CustomerDateRangePicker
  },
  data() {
    return {
      date: {
        startDate: "",
        endDate: ""
      },
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      storeList: [],
      employeeList: [],
      currentSorting: "",
      range: "",
      time_card: {
        employee_id: "",
        store_id: "",
        clock_in_date: "",
        clock_out_date: "",
        clock_in_time: "",
        clock_out_time: ""
      },
      filterObj: {
        sort_by: "",
        order_by: "ASC",
        store_id: "",
        employee_id: "",
        to_date: "",
        from_date: ""
      }
    };
  },
  methods: {
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },

    getList(page, sortBy, orderBy) {
      this.list = [];
      this.currentPage = page;

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );
      this.$api
        .getAPI({
          _action: "/time_card/list/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(
              this.$lang.messages.no_timecard_found
            );
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    getExport() {
      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      var queryParam = "";
      for (let key in this.filterObj) {
        if (queryParam == "") {
          queryParam += "?" + key + "=" + this.filterObj[key];
        } else {
          queryParam += "&" + key + "=" + this.filterObj[key];
        }
      }
      this.$api.getAndDownloadAPI({ _action: "/time_card/export_time_card/" +
          localStorage.getItem("client_id") +
          queryParam
      , _fileName: 'time_card.csv'})
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";

      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    },

    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },

    getEmployeeList() {
      this.$api
        .getAPI({ _action: `/employee/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.employeeList = res.list;
          }
        })
        .catch(e => {});
    },

    details(id) {
      this.time_card = {};
      this.$api
        .getAPI({
          _action: "/time_card/detail/" + id
        })
        .then(res => {
          this.time_card = res;
        });
    },

    setObj(id) {
      this.time_card.id = id;
      this.$refs.deleteTimeCardAlert.message = this.$lang.messages.confirm_delete_timecard;
    },

    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    },

    save() {
      this.$api
        .postAPI({
          _action: "/time_card/",
          _body: this.time_card,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          document.getElementById("cancel-btn").click();
          this.getList(1);
        })
        .catch(e => {
          console.log(e.message);
        });
    },

    gotoTimeCardAdd() {
      router.push("/add-time-card");
    },

    gotoTimeCardEdit(id) {
      router.push("/edit-time-card/" + id);
    },

    deleteTimeCard(e) {
      if (this.time_card.id) {
        this.$api
          .deleteAPI({
            _action: "/time_card/delete/" + this.time_card.id
          })
          .then(res => {
            this.$refs.deleteTimeCardAlert.close();
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });
            this.time_card.id = "";
            this.getList(1);
          })
          .catch(e => {
            this.$refs.deleteTimeCardAlert.close();
          });
      }
    },

    clearAddModal() {
      this.time_card.employee_id = "";
      this.time_card.store_id = "";
      this.time_card.clock_in_date = "";
      this.time_card.clock_out_date = "";
      this.time_card.clock_in_time = "";
      this.time_card.clock_out_time = "";
      this.$validator.reset();
      this.errors.clear();
    },
    EditTimeCard(id) {
      router.push("/edit-time-card/" + id);
    },
    formatDateUTCtoLocal(date) {

      return moment.utc(date).local().format("DD MMM YYYY HH:mm");
    }
  },
  mounted() {

    this.getStoreList();
    this.getList(1);
    this.getEmployeeList();
  }
};
</script>
<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-md-12 d-lg-flex justify-content-end">
          <div class="date-range-picker-wrap d-flex mb-lg-0 mb-3 w-xs-100" style="width: 304px">
            <CustomerDateRangePicker
              class="w-xs-100"
              :date.sync="date"
              @update="getList(1)"></CustomerDateRangePicker>
          </div>
          <div
            class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
            style="width: 180px;">
            <select v-model="filterObj.store_id" @click="getList(1)" class="form-control">
              <option value>{{$lang.messages.all_stores}}</option>
              <option v-for="store in storeList" :key="store.id" :value="store.id">{{store.name}}</option>
            </select>
          </div>
          <div
            class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
            style="width: 180px;">
            <select v-model="filterObj.employee_id" @click="getList(1)" class="form-control">
              <option value>{{$lang.messages.all_employees}}</option>
              <option
                v-for="employee in employeeList"
                :key="employee.id"
                :value="employee.id"
              >{{employee.name}}</option>
            </select>
          </div>

          <a
            href="javascript:void(0)"
            @click="gotoTimeCardAdd()"
            class="btn btn-primary px-4"
          >+ {{$lang.messages.add_timecard}}</a>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card rounded-5">
            <div class="pink-tape mt-2">
              <div class="row">
                <div class="col-lg-9 col-5 align-self-center">
                  <a
                    href="javascript:void(0)"
                    class="font-20 mb-0 text-regular text-hover-primary text-nowrap"
                    @click="getExport()"
                  >
                    {{$lang.messages.export}}
                    <i class="mdi mdi-download align-text-top"></i>
                  </a>
                </div>
              </div>
            </div>

            <div class="card-body table-responsive">
              <table class="table table-striped table-style-1">
                <thead>
                  <tr>
                    <th scope="col">Sr.no</th>
                    <th scope="col">{{$lang.messages.clock_in}}</th>
                    <th scope="col">{{$lang.messages.clock_out}}</th>
                    <th scope="col">{{$lang.messages.employee}}</th>
                    <th scope="col">{{$lang.messages.store}}</th>
                    <!-- <th scope="col" class="text-center">{{$lang.messages.total_hours}}</th> -->
                    <th class="text-right">{{$lang.messages.action}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(timecard,i) in list" :key="timecard.id">
                    <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                    <td
                      v-if="timecard.clock_in_date"
                    >{{formatDateUTCtoLocal(timecard.clock_in_date)}}</td>
                    <td v-else>{{timecard.timecard_status == 'MISSING' ? 'Missing':'Open'}}</td>
                    <td
                      v-if="timecard.clock_out_date"
                    >{{formatDateUTCtoLocal(timecard.clock_out_date)}}</td>
                    <td v-else>{{timecard.timecard_status == 'MISSING' ? 'Missing':'Open'}}</td>
                    <td>{{timecard.employee_name}}</td>
                    <td>{{timecard.store_name}}</td>
                    <!-- <td class="text-center">{{timecard.total_hours}}</td> -->

                    <td class="text-right pr-lg-4">
                      <a
                        @click="EditTimeCard(timecard.id)"
                        href="javascript:void(0)"
                        data-toggle="modal"
                        data-target="#AddCountry"
                        class="text-primary mr-2 font-18"
                      >
                        <i class="mdi mdi-pencil"></i>
                      </a>
                      <a
                        href="javascript:void(0)"
                        class="text-grey font-18"
                        data-toggle="modal"
                        data-target="#delete-TimeCard-Alert"
                        @click="setObj(timecard.id)"
                      >
                        <i class="far fa-trash-alt font-18 text-danger"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <ErrorComponent @retry="retry()" ref="errorComonent" />
            </div>
          </div>

          <div class="page-bottom-pagination text-right">
            <Pagination
              @page-change="pageChange"
              @items-per-page-change="itemsPerPageChange()"
              ref="listPagination"
            />
          </div>
        </div>

        <Alert
          @rightButtonEvent="deleteTimeCard($event)"
          v-bind:title="$lang.messages.delete_timecard"
          ref="deleteTimeCardAlert"
          tabindex="-1"
          aria-hidden="true"
          role="dialog"
          class="modal fade show"
          id="delete-TimeCard-Alert"
        />
      </div>
    </div>
  </div>
</template>
